import { render, staticRenderFns } from "./widgetCounter.vue?vue&type=template&id=42148098&scoped=true"
import script from "./widgetCounter.vue?vue&type=script&lang=js"
export * from "./widgetCounter.vue?vue&type=script&lang=js"
import style0 from "./widgetCounter.vue?vue&type=style&index=0&id=42148098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42148098",
  null
  
)

export default component.exports